import config from '../../config';
import { authHeader } from '../_helpers/auth-header';
import { createRequestCache } from '../Page/HomePage/floorDeckRequestCache';

const cache = createRequestCache(30000);

async function request(path, method = 'GET', body) {
    const response = await fetch(`${config.apiUrl}/module-accessibility${path}`, {
        method,
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
    const data = await response.json();

    if (!response.ok) {
        const error = new Error(data.error || data.message || 'Unable to load module accessibility.');
        error.status = response.status;
        throw error;
    }

    return data;
}

function read(path, force = false) {
    const key = JSON.stringify([authHeader().Authorization, path]);
    const loader = () => request(path);
    
    return force
        ? { data: cache.peek(key), revalidate: cache.get(key, loader, true) }
        : cache.getStaleWhileRevalidate(key, loader);
}

export const moduleAccessibilityService = {
    companies: () => read('/companies'),
    details: (company, force = false) => read(`?company=${encodeURIComponent(company)}`, force),
    async save(company, permissionIds, expectedPermissionIds) {
        cache.clear();
        try {
            return await request(`?company=${encodeURIComponent(company)}`, 'PUT', { permissionIds, expectedPermissionIds });
        } finally {
            cache.clear();
        }
    },
    clear: () => cache.clear(),
};
